import axios from "axios";
import {getStore} from '@/store/StoreInstance';
import loggingDevInfo from '@/services/log-dev-info';

export const http_headers_azure = {
  'accept': '*/*',
  'accept-language': 'en-US,en;q=0.9',
};

export default function apiRequest (
    url = '',
    method = 'get',
    body = null,
    headers = null,
    options = {},
  ) {
  if (!url) loggingDevInfo('You are trying to make a request without a URL!', 'warn');
  const defaultHeader = {
    "Content-Type": "application/json",
    "Country": getStore()?.state?.COUNTRY || 'en_US',
  }
  return axios({
    method,
    url,
    data: body,
    headers: headers || defaultHeader,
    ...options,
  })
    .then((response) => response.data)
    .catch((err) => { throw err })
}
